import React, { Component } from "react";
import Select, { AriaOnFocus } from "react-select";
import { Map, GoogleApiWrapper, Marker, Polyline } from "google-maps-react";
import mapMarker from "../../assets/img/map_marker.png";

import "react-tabs/style/react-tabs.css";
import {
  Button,
  FormGroup,
  // ControlLabel,
  FormControl,
  Row,
  Radio,
} from "react-bootstrap";
import { Modal, Checkbox } from "react-bootstrap";
import ShareLock from "../Tutorial/ShareLockGuide";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import NoDataFound from "../Errors/NoDataFound";
import Loading from "../../components/Loading/Loading";
import { fire, auth } from "../../firebase/index";
import "../../routes/app";
import {
  style,
  customLog,
  monthNamesShort,
  planToNumber,
  egeeTouchPlans,
} from "../../variables/Variables";
import LocksTable from "./selectmultiplelock";

//css
import "../../assets/css/mapview.css";
import "../../assets/css/maincss.css";

import "react-widgets/dist/css/react-widgets.css";
import "../../assets/css/header.css";

import NotificationSystem from "react-notification-system";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    startTimeTitle: "Select your start time",
    endTimeTitle: "Select your end time",
    grantAccessTitle: "Grant Access",
    descriptionSubtitle: "Grant an lock access to recipient",
    lockSharingTab: "Lock Sharing",
    step1Message: "Step 1 : Select a Lock",
    selectLockTitle: "Please Select A Lock",
    step2Message: "Step 2 : Select a Type",
    selectTypeTitle1: "Individual",
    selectTypeTitle2: "Group",
    step3IndividualMessage: "Step 3 : Select a Recipient",
    step3GroupMessage: "Step 3 : Select a Group",
    selectRecipientTitle: "Please Select a Recipient",
    step4Message: "Step 4 : Select sharing Type",
    step4RecurringOption: "Recurring",
    step4NormalOption: "Regular",
    step4RecurringTitle: "Select day(s) :",
    step4AccessTitle: "Access period",
    step4Start: "Start: ",
    step4End: "End: ",
    step4SelectDaily: "Select daily access:",
    step4FullDay: "Full-day Access",
    step4Timed: "Timed Access",
    step4FromOption: "From",
    step4ToOption: " to ",
    checkboxText: "Allow admin to share lock to others",
    // checkboxText: "Do not allow admin to share lock to others",
    step5SubMessage: "* For Multi Approve *",
    step5Message: "Step 5 : Select an Approval Admin",
    usernameTip:
      "The start & end time of a given share access. User will not be able to lock or unlock when access period expires.",
    usernameTip2:
      "Set approving members to approve the shared access before users is allowed to lock & unlock the padlock",
    usernameTip3:
      "When turned on. User is allowed to unlock & lock the padlock once within the access period",
    // step4Message: "Step 4 : Select an Admin for Multi Approve",
    timedAccessTitle: "Timed Access",
    unrestrictedTitle: "User will have unrestricted time access",
    sharingModeTitle: "Sharing Mode",
    sharingMode2Title: "Disable Shared Locks",
    onlineWarning: "Online: User has to be online to access lock",
    offlineWarning: "Offline: Once Shared Cannot Retract",
    online2Warning: "Only Non-Shared Locks Will Be Selectable",
    offline2Warning: "All Locks Are Selectable",
    emailHeader: "Email address",
    nameHeader: "Name",
    sendButton: "Send Remote Access",
    clearButton: "Clear All",
    alertmessage: "Your Recipient Has No EgeeTouch App, Please Install!",
    shareHistoryTab: "Share History",
    lockSchedulingTab: "Lock Scheduling",
    availableOnlineOnly: "Only Available For Online",
    mutliApprove: "Multi Approve",
    oneTimeAccess: "One Time Access",
    requestAccessFrom: "Request access from..",
    shareLockGuide: "Share Lock",
    exceededPlanLimits:
      "Please delete some members as you have exceeded plan limits",
    exceededLockLimits:
      "Please delete some locks as you have exceeded plan limits",
    invalidTime: "Please input a valid time for start time and end time",
    multiAccess: "Multiple Access of",
    singleAccess: "Access of",
    given: "given !",
    userWOApp1: "Please ensure",
    userWOApp2: "has eGeeTouch App !",
    selectAdmin: "Please select an admin for permission approval",
    emptyField: "Please select a Lock and Recipient",
    emptyFieldGroup: "Please select a Lock and Group",
    myLocksLabel: "My Locks",
    sharedLocksLabel: "Shared Locks",
    invalidLock:
      "You can only allow recipients to share locks that are owned by you, Please select another lock",
    invalidRecurring: "You must select at least 1 day for recurring access",
    invalidRecurringSelectedTime: "Please select a start and end time",
    invalidRecurringStartTime: "Start time can not be later than the end time",
    timedAccessLock1: "You are only allowed to share the lock between",
    timedAccessLock2: "and",
    timedAccessLock3: "",
    everyLabel: "Every ",
    recurringDaySun: "Sun",
    recurringDayMon: "Mon",
    recurringDayTue: "Tue",
    recurringDayWed: "Wed",
    recurringDayThu: "Thu",
    recurringDayFri: "Fri",
    recurringDaySat: "Sat",
    recurringCurrentlyUnavailable:
      "*Currently not available for Multi approval and One Time Access",
    tripStep1Label: "Step 1 : Name Your Trip",
    tripStep1Placeholder: "Enter the name of your trip",
    tripStep2Label: "Step 3 : Select Locks",
    tripStep3Label: "Step 4 : Select A Time",
    startLabel: "Start",
    endLabel: "End",
    tripStep4Label: "Step 5 : Select The Location / Path",
    selectedLocationsLabel: "Selected Locations",
    searchLocationPlaceholder: "Search for location",
    findLocationBtn: "Search",
    clearBtn: "Clear",
    editTripBtn: "Edit Trip",
    removeBtn: "Remove",
    errorMessage1: "Please enter a name for the trip",
    errorMessage2: "Please select a lock",
    errorMessage3: "Please select the location(s)",
    errorMessage4: "Invalid timeframe",
    step2: "Step 2 : Select Person In Charge",
    step2Placeholder: "Please Select Person In Charge",
    locationNotFound: "Location not found, please provide a valid address.",
    selectPIC: "Please select the person in charge for this trip",
    saveBtn: "Save Changes",
  },
  ja: {
    startTimeTitle: "アクセス開始時間",
    endTimeTitle: "アクセス終了時間",
    grantAccessTitle: "アクセス設定",
    descriptionSubtitle: "受信者にロックアクセスを許可する",
    lockSharingTab: "ロック共有",
    step1Message: "Step1　ロックを選択",
    selectLockTitle: "ハードウェア選択",
    step2Message: "Step2　種類を選択",
    selectTypeTitle1: "個別登録",
    selectTypeTitle2: "グループ",
    step3IndividualMessage: "Step3　メンバーを選択",
    step3GroupMessage: "Step3　グループを選択",
    selectRecipientTitle: "メンバー選択",
    step4Message: "Step 4　アクセススケジュールの選択",
    step4RecurringOption: "曜日選択",
    step4NormalOption: "無制限",
    step4RecurringTitle:
      "曜日選択（選択した曜日全て同じ時間帯の設定になります）",
    step4AccessTitle: "アクセス期間",
    step4Start: "開始日時: ",
    step4End: "終了日時: ",
    step4SelectDaily: "設定時間",
    step4FullDay: "24時間設定",
    step4Timed: "時間制限",
    step4FromOption: "から",
    step4ToOption: " まで ",
    checkboxText: "メンバーへロックのアクセス許可を承認する",
    // checkboxText: "Do not allow admin to share lock to others",
    step5SubMessage: "* マルチ承認 *",
    step5Message: "Step5　副管理者を選択",
    usernameTip:
      "共有アクセスの開始時刻と終了時刻。アクセス期間が終了すると、ユーザーはロックをロックまたはアンロックできません。",
    usernameTip2:
      "ユーザーがロックとアンロックを許可される前に、共有アクセスを承認するメンバーを設定します。",
    usernameTip3:
      "オンにすると、ユーザーはアクセス期間内にロックとアンロックを一度行うことができます",
    // step4Message: "Step 4 : Select an Admin for Multi Approve",
    timedAccessTitle: "タイムアクセス",
    unrestrictedTitle: "アクセス制限無し",
    sharingModeTitle: "アクセスモード",
    sharingMode2Title: "共有ロックを無効にする",
    onlineWarning: "オンライン（推奨）；オンラインでのアクセスを許可",
    offlineWarning: "オフライン：オフラインでのアクセスを許可",
    online2Warning: "共有されていないロックのみが選択可能です",
    offline2Warning: "すべてのロックが選択可能です",
    emailHeader: "Eメール",
    nameHeader: "名前",
    sendButton: "アクセス権限を与える",
    clearButton: "クリア",
    alertmessage:
      "エラーメッセージ 選択したサブユーザーは、アプリケーションのアカウントが未登録です。登録して下さい。",
    shareHistoryTab: "アクセス履歴",
    lockSchedulingTab: "ロックスケジューリング",
    availableOnlineOnly: "オンラインのみ有効",
    mutliApprove: "複数承認",
    oneTimeAccess: "ワンタイムアクセス",
    requestAccessFrom: "からのアクセスを要求する",
    shareLockGuide: "ロックを共有する",
    exceededPlanLimits:
      "ご使用プランの制限内でメンバーアカウント数を追加してください。",
    exceededLockLimits: "プランの制限を超えたため、ロックを削除してください。",
    invalidTime: "タイムアクセス開始時間と終了時間を入れて下さい。",
    multiAccess: "マルチ承認",
    singleAccess: "アクセス",
    given: "処理完了",
    userWOApp1: "確認",
    userWOApp2: "すでにアプリ登録済です。",
    selectAdmin: "承認アカウントを選択して下さい。",
    emptyField: "スマートロックとメンバーを選択",
    emptyFieldGroup: "スマートロックとグループを選択",
    myLocksLabel: "登録ロック一覧",
    sharedLocksLabel: "ロックをシェアする",
    invalidLock:
      "このアカウントで登録済のロックのみ選択することができます。登録済のロックを選択して下さい。",
    invalidRecurring:
      "定期的なアクセスには少なくとも1日を選択する必要があります。",
    invalidRecurringSelectedTime: "開始時間と終了時間を選択します。",
    invalidRecurringStartTime: "開始時間は終了時間の前を選択します。",
    timedAccessLock1: "シェアできるロックは",
    timedAccessLock2: "と",
    timedAccessLock3: "です。",
    everyLabel: "毎週 ",
    recurringDaySun: "日",
    recurringDayMon: "月",
    recurringDayTue: "火",
    recurringDayWed: "水",
    recurringDayThu: "木",
    recurringDayFri: "金",
    recurringDaySat: "土",
    recurringCurrentlyUnavailable:
      "※「曜日選択」でのマルチ承認、ワンタイムパスワードは現在使用できません。",
    tripStep1Label: "ステップ 1 : トリップの名前を付ける",
    tripStep1Placeholder: "トリップの名前を入力してください",
    tripStep2Label: "ステップ 3 : 錠を選択",
    tripStep3Label: "ステップ 4 : 時間を選択する",
    startLabel: "開始",
    endLabel: "終了",
    tripStep4Label: "ステップ 5 : 場所/経路を選択する",
    selectedLocationsLabel: "選択した場所",
    searchLocationPlaceholder: "場所を検索",
    findLocationBtn: "検索",
    clearBtn: "クリア",
    editTripBtn: "トリップを編集",
    removeBtn: "削除",
    errorMessage1: "トリップの名前を入力してください",
    errorMessage2: "ロックを選択してください",
    errorMessage3: "場所を選択してください",
    errorMessage4: "無効な時間枠",
    step2: "ステップ 2 : 責任者を選択",
    step2Placeholder: "責任者を選択してください",
    locationNotFound: "場所が見つかりません。有効な住所を入力してください。",
    selectPIC: "このトリップの責任者を選択してください",
    saveBtn: "変更を保存",
  },
  es: {
    startTimeTitle: "Selecciona tu hora de inicio",
    endTimeTitle: "Selecciona tu hora de fin",
    grantAccessTitle: "Conceder Acceso",
    descriptionSubtitle: "Conceder acceso a la candado al destinatario",
    lockSharingTab: "Compartir Candado",
    step1Message: "Paso 1: Selecciona una Candado",
    selectLockTitle: "Por favor, selecciona una candado",
    step2Message: "Paso 2: Selecciona un Tipo",
    selectTypeTitle1: "Individual",
    selectTypeTitle2: "Grupo",
    step3IndividualMessage: "Paso 3: Selecciona un Destinatario",
    step3GroupMessage: "Paso 3: Selecciona un Grupo",
    selectRecipientTitle: "Por favor, selecciona un destinatario",
    step4Message: "Paso 4: Selecciona el Tipo de Compartición",
    step4RecurringOption: "Recurrente",
    step4NormalOption: "Regular",
    step4RecurringTitle: "Selecciona día(s):",
    step4AccessTitle: "Período de acceso",
    step4Start: "Inicio: ",
    step4End: "Fin: ",
    step4SelectDaily: "Selecciona acceso diario:",
    step4FullDay: "Acceso todo el día",
    step4Timed: "Acceso por tiempo",
    step4FromOption: "Desde",
    step4ToOption: " a ",
    checkboxText: "Permitir al administrador compartir la candado con otros",
    // checkboxText: "Do not allow admin to share lock to others",
    step5SubMessage: "* Para Aprobación Múltiple *",
    step5Message: "Paso 5: Selecciona un Administrador de Aprobación",
    usernameTip:
      "La hora de inicio y fin de un acceso compartido. El usuario no podrá bloquear o desbloquear cuando expire el período de acceso.",
    usernameTip2:
      "Configura miembros aprobadores para que aprueben el acceso compartido antes de que los usuarios puedan bloquear y desbloquear la candado.",
    usernameTip3:
      "Cuando esté activado. El usuario podrá desbloquear y bloquear la candado una vez dentro del período de acceso",
    // step4Message: "Step 4 : Select an Admin for Multi Approve",
    timedAccessTitle: "Acceso por Tiempo",
    unrestrictedTitle: "El usuario tendrá acceso sin restricciones",
    sharingModeTitle: "Modo de Compartición",
    sharingMode2Title: "Deshabilitar Candados Compartidas",
    onlineWarning:
      "En línea: El usuario debe estar en línea para acceder a la candado",
    offlineWarning: "Fuera de línea: Una vez compartido no se puede retractar",
    online2Warning: "Solo las candados no compartidas serán seleccionables",
    offline2Warning: "Todas las candados son seleccionables",
    emailHeader: "Dirección de correo electrónico",
    nameHeader: "Nombre",
    sendButton: "Enviar Acceso Remoto",
    clearButton: "Limpiar Todo",
    alertmessage:
      "¡Tu destinatario no tiene la aplicación eGeeTouch, por favor instálala!",
    shareHistoryTab: "Historial de Compartición",
    lockSchedulingTab: "Programación de Candados",
    availableOnlineOnly: "Solo disponible en línea",
    mutliApprove: "Aprobación Múltiple",
    oneTimeAccess: "Acceso Único",
    requestAccessFrom: "Solicitar acceso de..",
    shareLockGuide: "Compartir Candado",
    exceededPlanLimits:
      "¡Por favor, elimina algunos miembros ya que has superado los límites del plan!",
    exceededLockLimits:
      "¡Por favor, elimina algunas candados ya que has superado los límites del plan!",
    invalidTime:
      "¡Por favor, introduce una hora válida para la hora de inicio y fin!",
    multiAccess: "Acceso Múltiple de",
    singleAccess: "Acceso de",
    given: "¡dado!",
    userWOApp1: "Por favor asegúrate de que",
    userWOApp2: "tiene la aplicación eGeeTouch!",
    selectAdmin:
      "Por favor, selecciona un administrador para la aprobación de permisos",
    emptyField: "Por favor selecciona una candado y un destinatario",
    emptyFieldGroup: "Por favor selecciona una candado y un grupo",
    myLocksLabel: "Mis Candados",
    sharedLocksLabel: "Candados Compartidas",
    invalidLock:
      "Solo puedes permitir que los destinatarios compartan candados que son de tu propiedad, por favor selecciona otra candado",
    invalidRecurring: "Debes seleccionar al menos 1 día para acceso recurrente",
    invalidRecurringSelectedTime:
      "Por favor selecciona una hora de inicio y fin",
    invalidRecurringStartTime:
      "La hora de inicio no puede ser más tarde que la hora de fin",
    timedAccessLock1: "Solo se te permite compartir la candado entre",
    timedAccessLock2: "y",
    timedAccessLock3: "",
    everyLabel: "Cada ",
    recurringDaySun: "Dom",
    recurringDayMon: "Lun",
    recurringDayTue: "Mar",
    recurringDayWed: "Mié",
    recurringDayThu: "Jue",
    recurringDayFri: "Vie",
    recurringDaySat: "Sáb",
    recurringCurrentlyUnavailable:
      "*Actualmente no disponible para Aprobación Múltiple y Acceso Único",
    tripStep1Label: "Paso 1 : Nombra tu Viaje",
    tripStep1Placeholder: "Ingresa el nombre de tu viaje",
    tripStep2Label: "Paso 3 : Seleccionar Candados",
    tripStep3Label: "Paso 4 : Selecciona un Horario",
    startLabel: "Inicio",
    endLabel: "Fin",
    tripStep4Label: "Paso 5 : Selecciona la Ubicación / Ruta",
    selectedLocationsLabel: "Ubicaciones Seleccionadas",
    searchLocationPlaceholder: "Buscar ubicación",
    findLocationBtn: "Buscar",
    clearBtn: "Limpiar",
    editTripBtn: "Editar Viaje",
    removeBtn: "Eliminar",
    errorMessage1: "Por favor, introduzca un nombre para el viaje",
    errorMessage2: "Por favor, seleccione un candado",
    errorMessage3: "Por favor, seleccione la(s) ubicación(es)",
    errorMessage4: "Periodo de tiempo no válido",
    step2: "Paso 2 : Seleccionar Persona a Cargo",
    step2Placeholder: "Por favor seleccione la persona a cargo",
    locationNotFound:
      "Ubicación no encontrada, proporcione una dirección válida.",
    selectPIC: "Por favor seleccione la persona a cargo de este viaje",
    saveBtn: "Guardar Cambios",
  },
});

class LockDropdownComponent extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeOTA = this.handleChangeOTA.bind(this);
    // Force Update
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.handlewindowShow = this.handlewindowShow.bind(this);
    this.eraseAll = this.eraseAll.bind(this);
    this.showSharedNotification = this.showSharedNotification.bind(this);

    this.state = {
      tripDetails: {},
      tripId: null,
      tripName: "",
      locationName: "",
      locklistArray: [],
      locationList: [],
      polylinePaths: [],
      markers: [],
      userFriendListArray: [],
      loading: true,
      invalidMemberLimit: true,
      invalidLockLimit: true,
      userArray: [],

      actualDateTime: 0,
      startDate: new Date(new Date().setMinutes(0, 0, 0)),
      endDate: new Date(new Date().setMinutes(0, 0, 0)),

      timechecked: false,
      isRetractMode: true,
      OTAMode: false,
      disabledState: false, //for OTA & Sharing Mode
      disabledStateMultiShare: false, //for Multishare & Sharing Mode

      //sharing variable
      selectedLock: null,

      calendarStartText: localizationStrings.startTimeTitle,
      calendarEndText: localizationStrings.endTimeTitle,

      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      startTime: null,
      endTime: null,

      selectedFriendsArray: [],
      isMultipleSendingMode: false,

      _notificationSystem: null,

      selectedLocks: [],
      selectedRecipients: [],
      showTable: false,

      selectedAdmins: [],
      adminDetails: [],
      showAdminLists: false,
      subtractAdminArray: [],
      subtractRecipientArray: [],

      showPopup: false,
      popupTitle: "",
      popupImage: [],

      limitApproval: 0,
      emptyArray: [],

      radioIndividualChecked: true,
      radioGroupChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,

      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      recurringFullDay: true,
      recurringTimed: false,

      groupListArray: [],
      selectedGroups: [],
      superAdminID: "",
      isSuperAdmin: false,
      checkboxChecked: false,
      checkboxChecked5: false,
      checkboxChecked6: false,

      isSharedLock: false,
      disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
      currentLanguage: "",
      historyArray: [],
      isDisabledSwitch: true,

      selectedPIC: null,

      centerPoint: { lat: 1.3521, lng: 103.8198 },
      mapZoom: 12,
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.detectOnLockDropdownChangeEvent = this.detectOnLockDropdownChangeEvent.bind(
      this
    );
    this.detectOnPICDropdownChangeEvent = this.detectOnPICDropdownChangeEvent.bind(
      this
    );
    this.handleRadioFullDay = this.handleRadioFullDay.bind(this);
    this.handleRadioTimeAccess = this.handleRadioTimeAccess.bind(this);
    this.handleTimedAccess = this.handleTimedAccess.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.handleFriendsArray = this.handleFriendsArray.bind(this);
    this.handleGroupsArray = this.handleGroupsArray.bind(this);
    this.handleChangeMultiSharing = this.handleChangeMultiSharing.bind(this);
    this.conditionRenderingMultiData = this.conditionRenderingMultiData.bind(
      this
    );
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleRadioIndividual = this.handleRadioIndividual.bind(this);
    this.handleRadioGroup = this.handleRadioGroup.bind(this);
    this.handleRadioNormal = this.handleRadioNormal.bind(this);
    this.handleRadioRecurring = this.handleRadioRecurring.bind(this);
    this.handleTabs = this.handleTabs.bind(this);
    this.handleCheck = this.handleCheck.bind(this);

    this.handleRecurringCheck = this.handleRecurringCheck.bind(this);
    this.convertStartTime = this.convertStartTime.bind(this);
    this.convertEndTime = this.convertEndTime.bind(this);
  }

  mapRef = React.createRef();

  snapshotToArray(snapshot) {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  }

  async handleStartDateChange(startDate) {
    var dateFormatted = startDate.getTime() / 1000;
    var actualDateTime = Math.floor(Date.now() / 1000 - 86400); // Buffer 24 hours from current time

    customLog(dateFormatted);

    var hour, minute;

    if (startDate.getHours() < 10) {
      hour = "0" + startDate.getHours();
    } else {
      hour = startDate.getHours();
    }

    if (startDate.getMinutes() === 0) {
      minute = startDate.getMinutes() + "0";
    } else {
      minute = startDate.getMinutes();
    }

    var dateString = `${
      monthNamesShort[startDate.getMonth()]
    } ${startDate.getDate()} ${startDate.getFullYear()}, ${hour} : ${minute}`;

    customLog(dateString);

    await this.setState({
      startDate: startDate,
      calendarStartText: startDate.toString(),
      selectedStartShareTime: parseInt(dateFormatted, 0),
      selectedStartTimeString: dateString,
      actualDateTime: actualDateTime.toString(),
    });

    // customLog(this.state.selectedStartShareTime)
  }

  async handleEndDateChange(endDate) {
    // customLog("handleEndDateChange " + endDate)
    var dateFormatted = endDate.getTime() / 1000;
    var actualDateTime = Math.floor(Date.now() / 1000 - 86400); // Buffer 24 hours

    var hour, minute;

    if (endDate.getHours() < 10) {
      hour = "0" + endDate.getHours();
    } else {
      hour = endDate.getHours();
    }

    if (endDate.getMinutes() === 0) {
      minute = endDate.getMinutes() + "0";
    } else {
      minute = endDate.getMinutes();
    }

    var dateString = `${
      monthNamesShort[endDate.getMonth()]
    } ${endDate.getDate()} ${endDate.getFullYear()}, ${hour} : ${minute}`;

    await this.setState({
      endDate: endDate,
      calendarEndText: endDate.toString(),
      selectedEndShareTime: parseInt(dateFormatted, 0),
      selectedEndTimeString: dateString,
      actualDateTime: actualDateTime.toString(),
    });
    // customLog(this.state.selectedEndShareTime)
  }

  handleStartTimeChange(startTime) {
    var timeFormatted = startTime.getTime() / 1000;

    customLog(startTime);
    this.setState({
      recurringStartText: startTime.toString(),
      startTime: startTime,
    });
  }

  handleEndTimeChange(endTime) {
    var timeFormatted = endTime.getTime() / 1000;

    this.setState({
      recurringEndText: endTime.toString(),
      endTime: endTime,
    });
  }

  handleTimedAccess(timechecked) {
    this.setState({ timechecked });

    if (!timechecked) {
      this.setState({ selectedEndShareTime: 0, selectedStartShareTime: 0 });
    }
  }

  handleChange(isRetractMode) {
    this.setState({ isRetractMode });
  }

  handleChangeOTA(OTAMode) {
    this.setState((prevState) => ({
      OTAMode: !prevState.OTAMode,
      disabledState: !prevState.OTAMode,
    }));
    if (OTAMode) {
      this.setState({
        isRetractMode: true,
      });
    }
  }

  fetchTripDetails = () => {
    const database = fire.database();
    const userId = auth.currentUser.uid;
    const tripsRef = database.ref(`activeTrip/${userId}`);

    tripsRef.once("value", (snapshot) => {
      const userTrips = snapshot.val();
      if (userTrips) {
        const tripsArray = Object.keys(userTrips).map((tripId) => ({
          tripId,
          ...userTrips[tripId],
        }));

        const selectedTrip = tripsArray.find(
          (trip) => trip.tripId === this.props.tripId
        );

        this.setState(
          {
            tripDetails: selectedTrip || null,
          },
          () => {
            if (this.state.tripDetails && this.state.tripDetails.locations) {
              const markers = this.state.tripDetails.locations.map(
                (location) => ({
                  lat: location.lat,
                  lng: location.lng,
                  name: location.name,
                })
              );

              const locations = this.state.tripDetails.locations.map(
                (location) => ({
                  lat: location.lat,
                  lng: location.lng,
                  name: location.name,
                })
              );

              const locationsCenter = this.calculateMidPoint(markers);
              const mapZoom = this.calculateSuitableMapZoom(markers);

              this.setState(
                {
                  tripName: this.state.tripDetails.tripName,
                  selectedPIC: {
                    PICEmail: this.state.tripDetails.PICEmail,
                    PICName: this.state.tripDetails.PICName,
                    PICUid: this.state.tripDetails.PICUid,
                  },
                  startDate: new Date(this.state.tripDetails.datestart),
                  endDate: new Date(this.state.tripDetails.endDate),
                  markers: markers,
                  locationList: locations,
                  centerPoint: locationsCenter,
                  mapZoom: mapZoom,
                  selectedLocks: this.state.tripDetails.lockSelected,
                  createdOn: this.state.tripDetails.createdOn,
                  createdBy: this.state.tripDetails.createdBy,
                },
                () => {
                  const map = this.mapRef.current.map;
                  map.setCenter(this.state.centerPoint);
                  this.updatePolylinePaths(
                    this.state.markers,
                    this.state.polylinePaths
                  );
                }
              );
            }
          }
        );
      } else {
        console.log("No details found for the selected trip");
      }
    });
  };

  componentDidMount() {
    this.setState(
      {
        _notificationSystem: this.refs.notificationSystem,
        tripId: this.props.tripId,
      },
      () => console.log(this.state.tripId)
    );
    const historyRef = fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey();

    // Set up the listener for changes in the MyShareHistory node
    historyRef.on("value", (snapshot) => {
      const tempArray = [];
      snapshot.forEach((childSnapshot) => {
        const item = childSnapshot.val();
        item.key = childSnapshot.key;
        tempArray.push(item);
      });
      this.setState({
        historyArray: tempArray.reverse(),
        loading: false,
      });
    });

    this.fetchTripDetails();
  }

  componentWillMount() {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        const snapshotVal = snapshot.val();
        // customLog(snapshotVal);
        let lockArrayWithShareRights = [];
        let lockDetails = {};
        let snapId = {};
        for (const eachLockId in snapshotVal) {
          if (
            snapshotVal[eachLockId].sharedBy === "" ||
            snapshotVal[eachLockId].sharePermissionType === 1
          ) {
            const currTimeStamp = Math.floor(Date.now() / 1000);

            //! Condition to check if Time Access Shared Lock is within the time period
            //? Check if it's shared lock with time access, if yes check whether current datetime is within access time period
            if (
              snapshotVal[eachLockId].sharedBy !== "" &&
              snapshotVal[eachLockId].shareStartTime > 0 &&
              snapshotVal[eachLockId].shareEndTime > 0 &&
              (snapshotVal[eachLockId].shareStartTime > currTimeStamp ||
                snapshotVal[eachLockId].shareEndTime < currTimeStamp)
            ) {
              //? Not Within Time Period, unable to access lock
            } else {
              snapId = { snapId: eachLockId };
              lockDetails = {
                ...snapshotVal[eachLockId],
                ...snapId,
              };
              lockArrayWithShareRights.push(lockDetails);
            }
          }
        }

        this.setState({
          locklistArray: lockArrayWithShareRights,
          loading: false,
        });
        // }
      })
      .catch((err) => {
        customLog(err);
      });

    // Replacing Axios
    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let friendListArray = [];
        let friendDetails = {};
        snapshot.forEach((user) => {
          // customLog(user.val());
          const userDetails = user.val();
          const userName = userDetails.friendName;
          const userEmail = userDetails.friendEmail;
          // friendListArray[userName] = userEmail;
          friendDetails = {
            userName: userName,
            userEmail: userEmail,
          };

          friendListArray.push(friendDetails);

          this.setState({
            userFriendListArray: friendListArray,
            loading: false,
          });
        });
        // customLog(friendListArray);
        // this.setState({userFriendListArray : friendListArray});
      })
      .catch((err) => customLog(err));

    //check if members is within the maxUsers limit
    //if it's more than the limit, user will not be able to share any lock
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            for (const eachMembers in members) {
              if (members[eachMembers].memberEmail === auth.currentUser.email) {
                const superAdminId = eachSuperAdmin.key;
                const maxUserLimit = eachSuperAdminDetails.payment.maxUsers;
                const maxUserLocks = eachSuperAdminDetails.payment.maxLocks;
                customLog(superAdminId);

                fire
                  .database()
                  .ref("MyAdminLocks/" + superAdminId)
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLocks) {
                      this.setState({
                        invalidLockLimit: true,
                      });
                      // this.showNotification(
                      //   localizationStrings.exceededLockLimits,
                      //   "error",
                      //   0,
                      //   ""
                      // );
                    } else {
                      this.setState({
                        invalidLockLimit: false,
                      });
                    }
                  });

                fire
                  .database()
                  .ref("groupAccounts/" + superAdminId + "/members")
                  .once("value")
                  .then((snapshot) => {
                    const childInDb = snapshot.numChildren();
                    if (childInDb > maxUserLimit) {
                      this.setState({
                        invalidMemberLimit: true,
                      });
                      // this.showNotification(
                      //   localizationStrings.exceededPlanLimits,
                      //   "error",
                      //   0,
                      //   ""
                      // );
                    } else {
                      this.setState({
                        invalidMemberLimit: false,
                      });
                    }
                  });
              }
            }
          });
        }
      });

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            // console.log(eachSuperAdmin.val());
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            let maxMulti;

            let adminDetailArray = [];
            let adminDetails = {};

            if (eachSuperAdminDetails.payment !== undefined) {
              if (eachSuperAdminDetails.payment.maxMulti !== undefined) {
                maxMulti = eachSuperAdminDetails.payment.maxMulti;
              }
            }

            for (const member in members) {
              if (members[member].memberEmail === auth.currentUser.email) {
                const superAdminId = eachSuperAdmin.key;
                const isSuperAdmin =
                  superAdminId === auth.currentUser.uid ? true : false;

                fire
                  .database()
                  .ref("groupAccounts/" + superAdminId + "/members")
                  .once("value")
                  .then((snapshot) => {
                    if (snapshot.exists()) {
                      snapshot.forEach((eachSnapshot) => {
                        const eachSnapshotDetail = eachSnapshot.val();
                        const memberEmail = eachSnapshotDetail.memberEmail;
                        const isAdmin = eachSnapshotDetail.isAdmin;
                        const isSuperAdmin = eachSnapshotDetail.isSuperAdmin;

                        if (isAdmin) {
                          fire
                            .database()
                            .ref("registeredIndustrialUsersOnPlatform")
                            .once("value")
                            .then((snapshot) => {
                              if (snapshot.exists()) {
                                snapshot.forEach((eachUser) => {
                                  const eachUserDetails = eachUser.val();
                                  const adminEmail = eachUserDetails.email;
                                  const adminUid = eachUserDetails.uid;
                                  const adminName = eachUserDetails.name;

                                  if (memberEmail === adminEmail) {
                                    if (adminEmail !== auth.currentUser.email) {
                                      adminDetails = {
                                        adminUid: adminUid,
                                        adminEmail: adminEmail,
                                        adminName: adminName,
                                      };
                                      adminDetailArray.push(adminDetails);
                                    }
                                  }
                                });
                              }
                            });
                        }
                      });
                    }
                  })
                  .then(() => {
                    this.setState({
                      adminDetails: adminDetailArray,
                      loading: false,
                      limitApproval: maxMulti,
                    });
                  });

                fire
                  .database()
                  .ref("GroupManagement/" + superAdminId)
                  .child(auth.currentUser.uid)
                  .once("value")
                  .then((snapshot) => {
                    let groupListArray = [];
                    // let groupDetails = {};
                    snapshot.forEach((group) => {
                      // customLog(user.val());
                      const groupDetails = group.val();
                      // const userName = userDetails.friendName;
                      // const userEmail = userDetails.friendEmail;
                      // friendListArray[userName] = userEmail;
                      // groupDetails = {
                      //   groupName: groupDetails.groupName,
                      //   groupID: groupDetails.groupID
                      // };

                      groupListArray.push(groupDetails);

                      this.setState({
                        groupListArray: groupListArray,
                        loading: false,
                      });
                    });
                  })
                  .catch((err) => customLog(err));

                this.setState({
                  superAdminID: superAdminId,
                  isSuperAdmin: isSuperAdmin,
                });
              }
            }
          });
        }
      });

    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    let groupAccountsPayment = fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("payment");

    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((eachSuperAdmin) => {
          if (eachSuperAdmin.key === auth.currentUser.uid) {
            //? if current user = super admin
            const superAdminPayment = eachSuperAdmin.val().payment;
            const superAdminCurrentPlan = superAdminPayment.plan;
            const superAdminMaxMulti = superAdminPayment.maxMulti;
            //? check if the user current subscription isit the old version (old version have no maxMulti)
            if (!superAdminMaxMulti) {
              //? if old subscription, update their maxMulti based on their current subscription plan
              customLog("updating old subscription maxMulti");
              if (superAdminCurrentPlan === 1 || superAdminCurrentPlan === 2) {
                groupAccountsPayment.child("maxMulti").set(4);
              } else if (superAdminCurrentPlan === 3) {
                groupAccountsPayment.child("maxMulti").set(8);
              } else if (superAdminCurrentPlan === 4) {
                //? if custom plan, we have to modify the firebase data directly because their plan might me special (clarify with project manager)
                groupAccountsPayment
                  .child("maxMulti")
                  .set(egeeTouchPlans.egeeTouchplan4.maxMulti);
                // alert(
                //   "Your current plan is out dated, Please contact the support team for help"
                // );
              }
            }
          }
        });
      });

    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot).reverse();
        this.setState({
          historyArray: tempArray,
          loading: false,
        });
      });

    const historyRef = fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .orderByKey();

    // Turn off the listener to avoid memory leaks
    historyRef.off("value");
  } // end of componentWillMount();

  forceUpdateHandler() {
    this.forceUpdate();
  }

  detectOnLockDropdownChangeEvent = (selectedOption) => {
    if (selectedOption !== null) {
      const lockDetails = selectedOption.value;
      if (
        lockDetails.sharedBy === "" ||
        lockDetails.sharePermissionType === 1
      ) {
        if (lockDetails.ownedBy === auth.currentUser.uid) {
          this.setState({
            selectedLock: lockDetails,
            isSharedLock: false,
            disabledStateShareLock: false,
          });
        } else {
          if (lockDetails.isOfflineLock === false) {
            this.setState({
              selectedLock: lockDetails,
              isSharedLock: true,
              checkboxChecked: false,
              isRetractMode: true,
              disabledStateShareLock: true,
            });
          } else {
            this.setState({
              selectedLock: lockDetails,
              isSharedLock: true,
              checkboxChecked: false,
              disabledStateShareLock: false,
            });
          }
        }
      }
    } else {
      this.setState({
        selectedLock: null,
        isSharedLock: false,
        disabledStateShareLock: false,
      });
    }
  };

  detectOnPICDropdownChangeEvent = (selectedOption) => {
    if (selectedOption !== null) {
      const memberDetails = selectedOption.value;
      const memberDetails2 = {
        PICEmail: memberDetails.memberEmail,
        PICName: memberDetails.memberName,
        PICUid: memberDetails.memberUid,
      };

      this.setState({
        selectedPIC: memberDetails2,
      });
    } else {
      this.setState({
        selectedPIC: null,
      });
    }
  };

  handleRadioTimeAccess() {
    this.setState({
      recurringFullDay: false,
      recurringTimed: true,
    });
  }

  handleRadioFullDay() {
    this.setState({
      recurringFullDay: true,
      recurringTimed: false,
    });
  }

  handleLocksArray(selectedLocks) {
    this.setState(
      {
        selectedLocks: selectedLocks,
      },
      () => {
        console.log(selectedLocks);
        console.log(this.state.selectedLocks);
      }
    );
  }

  handleFriendsArray(selectedFriends) {
    // console.log(selectedFriends);
    if (selectedFriends != "") {
      let subtractArrays = [];
      this.state.adminDetails.forEach((o1) => {
        var found = false;
        selectedFriends.forEach((o2) => {
          if (o1.adminEmail === o2.userEmail) {
            found = true;
          }
        });
        if (!found) {
          subtractArrays.push(o1);
        }
      });
      this.setState({
        // showTable: true,
        selectedRecipients: selectedFriends,
        subtractAdminArray: subtractArrays,
      });
    } else {
      customLog(selectedFriends);
      this.setState({
        // showTable: false,
        selectedRecipients: selectedFriends,
        subtractAdminArray: this.state.adminDetails,
      });
    }
  }

  handleGroupsArray(selectedGroups) {
    // console.log(selectedGroups);
    if (selectedGroups != "") {
      var allGroupMembersArray = [];
      for (var i = 0; i < selectedGroups.length; i++) {
        var eachGroup = selectedGroups[i].groupMembers;
        var eachMember = {};
        // var membersArray = [];
        _.map(eachGroup, (member) => {
          eachMember = {
            userName: member.memberName,
            userEmail: member.memberEmail,
          };

          // membersArray.push(eachMember);
          allGroupMembersArray.push(eachMember);
        });
      }
      // console.log(allGroupMembersArray);

      this.setState({
        // showTable: true,
        selectedGroups: selectedGroups,
        selectedRecipients: allGroupMembersArray,
      });
    } else {
      this.setState({
        // showTable: false,
        selectedGroups: [],
        selectedRecipients: [],
      });
    }
  }

  handleChangeMultiSharing(selectedAdministrators) {
    this.setState((prevState) => ({
      showAdminLists: !prevState.showAdminLists,
      disabledStateMultiShare: !prevState.showAdminLists,
      isRetractMode: true,
    }));

    if (selectedAdministrators) {
      if (selectedAdministrators !== true && selectedAdministrators !== false) {
        let subtractArrays = [];
        this.state.userFriendListArray.forEach((o1) => {
          var found = false;
          selectedAdministrators.forEach((o2) => {
            if (o1.userEmail === o2.adminEmail) {
              found = true;
            }
          });
          if (!found) {
            subtractArrays.push(o1);
          }
        });
        this.setState({
          showAdminLists: true,

          selectedAdmins: selectedAdministrators,
          subtractRecipientArray: subtractArrays,
          disabledStateMultiShare: true,
        });
      }
    } else {
      this.setState({
        showAdminLists: false,
        selectedAdmins: [],
        subtractRecipientArray: this.state.userFriendListArray,
        disabledStateMultiShare: false,
      });
    }
  }

  conditionRenderingMultiData(showAdminLists) {
    if (showAdminLists) {
      if (this.state.selectedGroups.length > 0) {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.adminDetails;
        }
      } else if (this.state.selectedRecipients.length > 0) {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.subtractAdminArray;
        }
      } else {
        if (this.state.selectedAdmins.length >= this.state.limitApproval) {
          return this.state.emptyArray;
        } else {
          return this.state.adminDetails;
        }
      }
    }
  }

  renderDropdown = () => {
    const historylistdata = _.map(this.state.historyArray, (historyData) => {
      const name = historyData.lockName;
      return {
        name: name,
      };
    });

    const typeOfLocks = [
      localizationStrings.myLocksLabel,
      localizationStrings.sharedLocksLabel,
    ];

    console.log(this.state.locklistArray);

    let filteredLocklistArray = this.state.locklistArray;

    if (this.state.checkboxChecked5) {
      const lockModel = 10;
      filteredLocklistArray = filteredLocklistArray.filter(
        (lockData) => lockData.Type !== lockModel
      );
    }

    if (this.state.checkboxChecked6) {
      const lockModel = 4;
      filteredLocklistArray = filteredLocklistArray.filter(
        (lockData) => lockData.Type !== lockModel
      );
    }

    return typeOfLocks.map((eachType) => {
      return {
        label: eachType,
        options: filteredLocklistArray
          .filter(
            (lockData) =>
              (lockData.ownedBy === auth.currentUser.uid &&
                eachType === localizationStrings.myLocksLabel) ||
              (lockData.ownedBy !== auth.currentUser.uid &&
                eachType === localizationStrings.sharedLocksLabel &&
                lockData.sharedLock)
          )
          .filter((lockData) => {
            return !(
              historylistdata.find((item) => item.name === lockData.Name) &&
              !this.state.isDisabledSwitch
            );
          })
          .map((lockData) => {
            return {
              value: lockData,
              label: lockData.Name,
            };
          }),
      };
    });
  };

  renderDropdown2 = () => {
    const groupMembers = [];

    fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("members")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((member) => {
          const memberData = member.val();
          groupMembers.push({
            value: memberData,
            label: memberData.memberName + " (" + memberData.memberEmail + ")",
          });
        });
      });

    return groupMembers;
  };

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  clearForm() {
    document.getElementById("grantAccessForm").reset();
    this.setState({
      endDate: new Date(new Date().setMinutes(0, 0, 0)),
      startDate: new Date(new Date().setMinutes(0, 0, 0)),
      calendarStartText: "Select your start time",
      calendarEndText: "Select your end time",
      selectedLock: null,
      radioIndividualChecked: true,
      radioGroupChecked: false,
      selectedRecipients: [],
      selectedGroups: [],
      showTable: false,
      selectedAdmins: [],
      showAdminLists: false,
      subtractAdminArray: [],
      subtractRecipientArray: [],
      checkboxChecked: false,
      isSharedLock: false,

      // recurring access
      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      recurringDailyAccessDropDown: "Full-day Access",

      radioNormalChecked: true,
      radioRecurringChecked: false,

      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      recurringFullDay: true,
      recurringTimed: false,

      startTime: null,
      endTime: null,

      // Reset Switch Buttons
      timechecked: false,
      isRetractMode: true,
      OTAMode: false,
      disabledState: false, //for OTA & Sharing Mode
      disabledStateMultiShare: false, //for Multishare & Sharing Mode
      disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
    });
  }

  handlewindowShow(event) {
    event.preventDefault();
  }

  eraseAll() {
    // window.location.reload(false);
    this.setState({
      tripName: "",
      selectedPIC: null,
      radioIndividualChecked: true,
      radioGroupChecked: false,
      selectedLocks: [],
      startDate: new Date(new Date().setMinutes(0, 0, 0)),
      endDate: new Date(new Date().setMinutes(0, 0, 0)),
      markers: [],
      polylinePaths: [],
      locationList: [],
    });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "bc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  showSharedNotification() {
    const isMultipleSendingMode = this.state.isMultipleSendingMode;
    const selectedLock = this.state.selectedLock;

    customLog("runned");
    customLog(isMultipleSendingMode);

    if (isMultipleSendingMode) {
      // this.showNotification(
      //   `${localizationStrings.multiAccess} ${selectedLock.Name} ${localizationStrings.given}`,
      //   "success",
      //   5
      // );

      this.setState({
        selectedLock: null,
      });
    } else {
      // this.showNotification(
      //   `${localizationStrings.singleAccess} ${selectedLock.Name} ${localizationStrings.given}`,
      //   "success",
      //   5
      // );
    }
  }
  handlePopupOpen() {
    this.setState({
      showPopup: true,
      popupTitle: localizationStrings.shareLockGuide,
      popupImage: [<ShareLock />],
    });
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  handleRadioIndividual() {
    this.setState({
      radioIndividualChecked: true,
      radioGroupChecked: false,
      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      // subtractAdminArray: this.state.adminDetails,
      // selectedAdmins: [],
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,
    });
  }

  handleRadioGroup() {
    this.setState({
      radioIndividualChecked: false,
      radioGroupChecked: true,
      selectedGroups: [],
      selectedRecipients: [],
      showTable: false,
      // subtractAdminArray: this.state.adminDetails,
      // selectedAdmins: [],
      checkboxChecked: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      // Set to default values when disabling One Time Access Switch for Group Sharing
      OTAMode: false,
      disabledState: false,
    });
  }

  handleRadioNormal() {
    this.setState({
      timechecked: false,

      recurringStartText: localizationStrings.startTimeTitle,
      recurringEndText: localizationStrings.endTimeTitle,

      startTime: null,
      endTime: null,

      recurringFullDay: true,
      recurringTimed: false,

      //monday - sunday set all false
      recurringCheckMon: false,
      recurringCheckTue: false,
      recurringCheckWed: false,
      recurringCheckThu: false,
      recurringCheckFri: false,
      recurringCheckSat: false,
      recurringCheckSun: false,

      radioNormalChecked: true,
      radioRecurringChecked: false,
    });
  }

  handleRadioRecurring() {
    this.setState({
      timechecked: true,

      OTAMode: false,
      showAdminLists: false,

      radioNormalChecked: false,
      radioRecurringChecked: true,
    });
  }

  handleTabs(key) {
    if (key === 0) {
      this.setState({
        endDate: new Date(new Date().setMinutes(0, 0, 0)),
        startDate: new Date(new Date().setMinutes(0, 0, 0)),
        calendarStartText: "Select your start time",
        calendarEndText: "Select your end time",
        selectedLock: null,
        radioIndividualChecked: true,
        radioGroupChecked: false,
        selectedRecipients: [],
        selectedGroups: [],
        showTable: false,
        selectedAdmins: [],
        showAdminLists: false,
        subtractAdminArray: [],
        subtractRecipientArray: [],
        checkboxChecked: false,
        isSharedLock: false,

        // Reset Switch Buttons
        timechecked: false,
        isRetractMode: true,
        OTAMode: false,
        disabledState: false, //for OTA & Sharing Mode
        disabledStateMultiShare: false, //for Multishare & Sharing Mode
        disabledStateShareLock: false, //for OnlineSharedLock & Sharing Mode
      });
    }
  }

  handleCheck(event) {
    // console.log(event.target.checked);
    this.setState({
      checkboxChecked: event.target.checked,

      // Set to default values when disabling One Time Access Switch
      OTAMode: false,
      disabledState: false,

      // Set to default values when disabling Multi Approve Switch
      showAdminLists: false,
      disabledStateMultiShare: false,
      selectedAdmins: [],
    });
  }

  handleRecurringCheck(event) {
    if (event.target.name === "recurringCheckMon") {
      this.setState({ recurringCheckMon: event.target.checked });
    } else if (event.target.name === "recurringCheckTue") {
      this.setState({ recurringCheckTue: event.target.checked });
    } else if (event.target.name === "recurringCheckWed") {
      this.setState({ recurringCheckWed: event.target.checked });
    } else if (event.target.name === "recurringCheckThu") {
      this.setState({ recurringCheckThu: event.target.checked });
    } else if (event.target.name === "recurringCheckFri") {
      this.setState({ recurringCheckFri: event.target.checked });
    } else if (event.target.name === "recurringCheckSat") {
      this.setState({ recurringCheckSat: event.target.checked });
    } else if (event.target.name === "recurringCheckSun") {
      this.setState({ recurringCheckSun: event.target.checked });
    }
  }

  convertStartTime(startTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(startTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(startTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(startTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const start = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(startTime * 1000);

      return start;
    }
  }

  convertEndTime(endTime) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanDate =
        new Intl.DateTimeFormat("ja-JP", {
          year: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          month: "numeric",
        }).format(endTime * 1000) +
        new Intl.DateTimeFormat("ja-JP", {
          day: "numeric",
        }).format(endTime * 1000);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hourCycle: "h12",
        hour: "numeric",
        minute: "2-digit",
      }).format(endTime * 1000);

      return japanDate + " " + japanTime;
    } else {
      const end = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit"
      }).format(endTime * 1000);

      return end;
    }
  }

  updateLockChanges = (data) => {
    this.handleLocksArray(data);
  };

  updateRecipientChanges = (data) => {
    this.handleFriendsArray(data);
  };

  updateGroupChanges = (data) => {
    this.handleGroupsArray(data);
  };

  updateAdminChanges = (data) => {
    this.handleChangeMultiSharing(data);
  };

  handleSwitchChange = (updatedSwitchValue) => {
    this.setState({ isDisabledSwitch: updatedSwitchValue });
  };

  onCheckboxChange4 = (updatedValue) => {
    this.setState({ checkboxChecked5: updatedValue });
  };

  onCheckboxChange5 = (updatedValue) => {
    this.setState({ checkboxChecked6: updatedValue });
  };

  async getLocationName(lat, lng) {
    const { google } = this.props;
    try {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

      return new Promise((resolve, reject) => {
        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            reject("No address found");
          }
        });
      });
    } catch (error) {
      console.error("Error fetching location name:", error);
      return "Unnamed Location";
    }
  }

  onMapClick = async (mapProps, map, clickEvent) => {
    const { markers, polylinePaths, locationList } = this.state;
    const newMarker = {
      lat: clickEvent.latLng.lat(),
      lng: clickEvent.latLng.lng(),
    };

    const name = await this.getLocationName(newMarker.lat, newMarker.lng);

    const updatedMarkers = [...markers, { ...newMarker, name: name }];
    this.setState({ markers: updatedMarkers });

    const updatedLocationList = [...locationList, { ...newMarker, name: name }];
    this.setState({ locationList: updatedLocationList });

    if (updatedMarkers.length > 1) {
      this.updatePolylinePaths(updatedMarkers, polylinePaths);
    }
  };

  onLocationNameChange = (e) => {
    this.setState({ locationName: e.target.value });
  };

  onFindLocation = () => {
    const { locationName } = this.state;
    const { google } = this.props;
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: locationName }, (results, status) => {
      if (status === "OK" && results[0]) {
        const { lat, lng } = results[0].geometry.location;
        const newLocation = {
          name: locationName,
          lat: lat(),
          lng: lng(),
        };
        const newMarker = { lat: lat(), lng: lng(), name: locationName };
        const updatedMarkers = [...this.state.markers, newMarker];

        this.setState(
          (prevState) => ({
            markers: updatedMarkers,
            locationList: [...prevState.locationList, newLocation],
          }),
          () => {
            this.setState(
              {
                centerPoint: this.calculateMidPoint(this.state.markers),
                mapZoom: this.calculateSuitableMapZoom(this.state.markers),
                locationName: "",
              },
              () => {
                const map = this.mapRef.current.map;
                map.setCenter(this.state.centerPoint);
              }
            );
          }
        );
        if (updatedMarkers.length > 1) {
          this.updatePolylinePaths(updatedMarkers, this.state.polylinePaths);
        }
      } else {
        // this.showNotification(
        //   `${localizationStrings.locationNotFound}`,
        //   "error",
        //   3
        // );
        console.error(
          "Geocode was not successful for the following reason:",
          status
        );
      }
    });
  };

  onDeleteLocation = (index) => {
    const updatedMarkers = this.state.markers.filter((_, i) => i !== index);
    const updatedLocationList = this.state.locationList.filter(
      (_, i) => i !== index
    );

    this.setState({
      markers: updatedMarkers,
      locationList: updatedLocationList,
    });

    if (updatedMarkers.length > 1) {
      const directionsService = new this.props.google.maps.DirectionsService();

      const calculatePaths = () => {
        const promises = [];

        for (let i = 0; i < updatedMarkers.length - 1; i++) {
          const origin = updatedMarkers[i];
          const destination = updatedMarkers[i + 1];

          promises.push(
            new Promise((resolve, reject) => {
              directionsService.route(
                {
                  origin,
                  destination,
                  travelMode: this.props.google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                  if (status === "OK") {
                    resolve(response.routes[0].overview_path);
                  } else {
                    reject("Directions request failed due to " + status);
                  }
                }
              );
            })
          );
        }

        return Promise.all(promises);
      };

      calculatePaths()
        .then((paths) => {
          this.setState({ polylinePaths: paths });
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      this.setState({ polylinePaths: [] });
    }
  };

  onReorderLocation = (index) => {
    if (index > 0 && index < this.state.locationList.length) {
      const updatedLocationList = [...this.state.locationList];
      const updatedMarkers = [...this.state.markers];

      const tempLocation = updatedLocationList[index];
      updatedLocationList[index] = updatedLocationList[index - 1];
      updatedLocationList[index - 1] = tempLocation;

      const tempMarker = updatedMarkers[index];
      updatedMarkers[index] = updatedMarkers[index - 1];
      updatedMarkers[index - 1] = tempMarker;

      this.setState({
        locationList: updatedLocationList,
        markers: updatedMarkers,
      });

      const directionsService = new this.props.google.maps.DirectionsService();

      const calculatePaths = () => {
        const promises = [];

        for (let i = 0; i < updatedMarkers.length - 1; i++) {
          const origin = updatedMarkers[i];
          const destination = updatedMarkers[i + 1];

          promises.push(
            new Promise((resolve, reject) => {
              directionsService.route(
                {
                  origin,
                  destination,
                  travelMode: this.props.google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                  if (status === "OK") {
                    resolve(response.routes[0].overview_path);
                  } else {
                    reject("Directions request failed due to " + status);
                  }
                }
              );
            })
          );
        }

        return Promise.all(promises);
      };

      calculatePaths()
        .then((paths) => {
          this.setState({ polylinePaths: paths });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  updatePolylinePaths = (markers, paths) => {
    const { google } = this.props;

    const directionsService = new google.maps.DirectionsService();

    let i = paths.length > 0 ? paths.length - 1 : 0;

    while (i < markers.length - 1) {
      const origin = markers[i];
      const destination = markers[i + 1];

      directionsService.route(
        {
          origin,
          destination,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === "OK") {
            const route = response.routes[0].overview_path;
            paths.push(route);
            this.setState({ polylinePaths: paths });
          } else {
            console.error("Directions request failed due to " + status);
          }
        }
      );

      i++;
    }
  };

  onKeyDown = (event) => {
    if (event.key === "Enter") {
      this.onFindLocation();
    }
  };
  handleTripNameChange = (event) => {
    this.setState({ tripName: event.target.value });
  };

  editActiveTrip = () => {
    if (this.state.tripName === "") {
      // this.showNotification(
      //   `${localizationStrings.errorMessage1}`,
      //   "error",
      //   5
      // );
    } else if (this.state.selectedPIC === null) {
      // this.showNotification(
      //   `${localizationStrings.selectPIC}`,
      //   "error",
      //   5
      // );
    } else if (this.state.selectedLocks.length === 0) {
      // this.showNotification(
      //   `${localizationStrings.errorMessage2}`,
      //   "error",
      //   5
      // );
    } else if (this.state.locationList.length === 0) {
      // this.showNotification(
      //   `${localizationStrings.errorMessage3}`,
      //   "error",
      //   5
      // );
    } else if (
      this.state.startDate >= this.state.endDate ||
      this.state.endDate <= new Date()
    ) {
      // this.showNotification(
      //   `${localizationStrings.errorMessage4}`,
      //   "error",
      //   5
      // );
    } else {
      const databaseRef = fire.database().ref("activeTrip");

      const tripId = this.state.tripId;

      const tripData = {
        datestart: this.state.startDate.toString(),
        endDate: this.state.endDate.toString(),
        tripName: this.state.tripName,
        PICEmail: this.state.selectedPIC.PICEmail,
        PICName: this.state.selectedPIC.PICName,
        PICUid: this.state.selectedPIC.PICUid,
        lockSelected: [...this.state.selectedLocks],
        locations: this.state.locationList.map((location, index) => ({
          locationId: `TripId${index + 1}`,
          name: location.name,
          lat: location.lat,
          lng: location.lng,
          status: "Pending Arrival",
          remarks: "-",
        })),
        Status: "Inactive",
        createdOn: this.state.createdOn,
        createdBy: this.state.createdBy,
      };

      databaseRef
        .child(auth.currentUser.uid)
        .child(tripId)
        .set(tripData)
        .then(() => {
          console.log("Trip data updated successfully!");
          // window.location.reload(false);
          if (this.props.onSave) {
            this.props.onSave();
          }
        })
        .catch((error) => {
          console.error("Error editing data in active trip: ", error);
          if (this.props.onFail) {
            this.props.onFail();
          }
        });
    }
  };

  sendToActiveTrip = () => {
    const databaseRef = fire.database().ref("activeTrip");

    const tripId = databaseRef.push().key;

    const tripData = {
      datestart: this.state.startDate.toString(),
      endDate: this.state.endDate.toString(),
      tripName: this.state.tripName,
      lockSelected: this.state.selectedLock.Name,
      locations: this.state.locationList.map((location, index) => ({
        locationId: `TripId${index + 1}`,
        name: location.name,
        lat: location.lat,
        lng: location.lng,
      })),
      Status: "Inactive",
    };

    databaseRef
      .child(auth.currentUser.uid)
      .child(tripId)
      .set(tripData)
      .then(() => {
        console.log("Data added to active trip successfully!");
        window.location.reload(false);
      })
      .catch((error) => {
        console.error("Error adding data to active trip: ", error);
      });
  };

  calculateMidPoint = (locations) => {
    let minLat = 90;
    let minLng = 180;
    let maxLat = -90;
    let maxLng = -180;
    let midLat = 0;
    let midLng = 0;
    const locationCount = locations.length;

    if (locationCount === 1) {
      locations.forEach((location) => {
        midLat = location.lat;
        midLng = location.lng;
      });

      return {
        lat: midLat,
        lng: midLng,
      };
    } else {
      locations.forEach((location) => {
        if (location.lat > maxLat) {
          maxLat = location.lat;
        }
        if (location.lat < minLat) {
          minLat = location.lat;
        }
        if (location.lng > maxLng) {
          maxLng = location.lng;
        }
        if (location.lng < minLng) {
          minLng = location.lng;
        }
      });

      midLat = (maxLat + minLat) / 2;
      midLng = (maxLng + minLng) / 2;

      return {
        lat: midLat,
        lng: midLng,
      };
    }
  };

  calculateSuitableMapZoom = (locations) => {
    let minLat = 90;
    let minLng = 180;
    let maxLat = -90;
    let maxLng = -180;
    let latDiff = 0;
    let lngDiff = 0;
    let diff = 0;
    const locationCount = locations.length;

    if (locationCount === 1) {
      return 12;
    } else {
      locations.forEach((location) => {
        if (location.lat > maxLat) {
          maxLat = location.lat;
        }
        if (location.lat < minLat) {
          minLat = location.lat;
        }
        if (location.lng > maxLng) {
          maxLng = location.lng;
        }
        if (location.lng < minLng) {
          minLng = location.lng;
        }
      });

      latDiff = maxLat - minLat;
      lngDiff = maxLng - minLng;

      if (latDiff === lngDiff || latDiff > lngDiff) {
        diff = latDiff;
      } else if (latDiff < lngDiff) {
        diff = lngDiff;
      }

      if (diff <= 0.15) {
        return 12;
      } else if (diff > 0.15 && diff <= 0.3) {
        return 11;
      } else if (diff > 0.3 && diff <= 0.6) {
        return 10;
      } else if (diff > 0.6 && diff <= 1.2) {
        return 9;
      } else if (diff > 1.2 && diff <= 2.4) {
        return 8;
      } else if (diff > 2.4 && diff <= 4.8) {
        return 7;
      } else if (diff > 4.8 && diff <= 9.6) {
        return 6;
      } else if (diff > 9.6 && diff <= 19.2) {
        return 5;
      } else if (diff > 19.2 && diff <= 38.4) {
        return 4;
      } else if (diff > 38.4 && diff <= 76.8) {
        return 3;
      } else if (diff > 76.8 && diff <= 153.6) {
        return 2;
      } else {
        return 1;
      }
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const { locationName } = this.state;
    const { markers, polylinePaths } = this.state;
    // const {
    //   localizationStrings,
    //   isDisabledSwitch,
    //   handleSwitchChange,
    //   onCheckboxChange4,
    //   onCheckboxChange5,
    // } = this.props;
    const auditTrailMergedData = _.map(this.state.mergedDataArray, (atData) => {
      // customLog(atData);
      // const testMerge = atData.Latitude + atData.Longitude
      // console.log(testMerge)
      var address = [];
      address.Latitude = atData.Latitude;
      address.Longitude = atData.Longitude;
      address.Placemark = atData.Placemark;

      if (
        this.state.selectedLockModel === 4 ||
        this.state.selectedLockModel === 10
      ) {
        //   console.log("tagID is " + atData.tagId);
        //  console.log("checking method is " + atData.method);
        //create an empty variable
        var tempLockStatus;
        //check if auditDeciValue is between 250 and 254
        if (atData.auditDeciValue >= 250 && atData.auditDeciValue <= 254) {
          tempLockStatus = "LOCKED";
        } else {
          //if auditDeciValue is not between 250 and 254, and value is undefined or null ; checked lockedStatus, if lockStatus exists
          // UNLOCKED or LOCKED, display those values, else display default UNLOCKED value
          tempLockStatus = atData.lockedStatus
            ? atData.lockedStatus
            : "UNLOCKED";
        }

        return {
          email: atData.tagId ? "N/A" : atData.userEmail,
          tagName: !atData.tagName ? "N/A" : atData.tagName, // If no tagname, display N/A
          tagId: atData.tagId ? atData.tagId : "N/A", //Check if is tag, if no tag is N/A
          // status: atData.lockedStatus ? atData.lockedStatus : "UNLOCKED", //CHECK IF UNDEFINNED
          status: tempLockStatus, //CONDITIONS SHOWN BEFORE RETURN STATEMENT
          dateTime: atData.time || atData.auditTrailTime,
          address: address ? address : "N/A", //Check for UNDEFINNED
          method: {
            type: atData.method,
            tagId: atData.tagId,
            // lockStatus: atData.method === "Bluetooth" ? atData.lockedStatus : atData.method === "FOB" ? "UNLOCKED" : atData.method === "Passcode" ? atData.auditDeciValue : "N.A",
            lockStatus:
              atData.method === "Bluetooth"
                ? atData.lockedStatus
                : atData.method === "FOB"
                ? atData.auditDeciValue
                : atData.method === "Passcode"
                ? atData.auditDeciValue
                : "N.A",
          },
        };
      } else if (
        this.state.selectedLockModel === 7 ||
        this.state.selectedLockModel === 8 ||
        this.state.selectedLockModel === 9
      ) {
        // console.log("atData.lockedStatus is " + atData.lockedStatus);
        return {
          email: atData.passcodeName ? "N/A" : atData.userEmail,
          passcodeName: !atData.passcodeName ? "N/A" : atData.passcodeName, // If no passcodeName, display N/A
          status: atData.lockedStatus ? atData.lockedStatus : "UNLOCKED", //CHECK IF UNDEFINNED
          dateTime: atData.time || atData.auditTrailTime,
          address: address ? address : "N/A", //Check for UNDEFINNED
          method: {
            type: atData.method,
            auditDeciValue: atData.auditDeciValue,
            // lockStatus: atData.method === "Bluetooth" ? atData.lockedStatus : atData.method === "FOB" ? "UNLOCKED" : atData.method === "Passcode" ? atData.auditDeciValue : "N.A",
            lockStatus:
              atData.method === "Bluetooth"
                ? atData.lockedStatus
                : atData.method === "FOB"
                ? atData.auditDeciValue
                : atData.method === "Passcode"
                ? atData.auditDeciValue
                : "N.A",
          },
        };
      }
    });
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <br />
        <br />
        <div
          style={{
            // maxWidth: "80%",
            padding: "0 20px 0 20px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <form id="grantAccessForm" onSubmit={this.handlewindowShow}>
            <FormGroup>
              <div
                className={"displayBlock"}
                // style={{ display: "flex" }}
              >
                <div
                  className={"dropDownInput"}
                  style={{
                    padding: "0% 0%",
                    // width: "400px"
                  }}
                >
                  <h5
                    style={{
                      fontSize: "1.8em",
                      fontWeight: "bolder",
                      marginTop: "-20px",
                    }}
                  >
                    {localizationStrings.tripStep1Label}
                  </h5>
                  <br></br>
                  <div style={{ flex: 1 }}>
                    <FormControl
                      type="text"
                      placeholder={localizationStrings.tripStep1Placeholder}
                      value={this.state.tripName}
                      onChange={this.handleTripNameChange}
                      style={{
                        border: "4px solid #3c3e41",
                        borderRadius: "12px",
                        "::placeholder": { color: "black", fontWeight: "bold" },
                      }}
                    />
                  </div>
                  <br />
                  <br />
                  <h5
                    style={{
                      fontSize: "1.8em",
                      fontWeight: "bolder",
                    }}
                  >
                    {localizationStrings.step2}
                  </h5>
                  <br></br>
                  <Select
                    value={
                      this.state.selectedPIC
                        ? {
                            label:
                              this.state.selectedPIC.PICName +
                              " (" +
                              this.state.selectedPIC.PICEmail +
                              ")",
                            value: this.state.selectedPIC,
                          }
                        : null
                    }
                    onChange={this.detectOnPICDropdownChangeEvent}
                    options={this.renderDropdown2()}
                    formatOptionLabel={({ label }) => label}
                    isClearable={true}
                    placeholder={localizationStrings.step2Placeholder}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        outline: "none",
                        boxShadow: state.isFocused
                          ? "none"
                          : provided.boxShadow,
                        borderColor: state.isFocused
                          ? "black"
                          : provided.borderColor,
                        width: "100%",
                        backgroundColor: "white",
                        color: "black",
                        fontWeight: "bold",
                        border: "4px solid #3c3e41",
                        borderRadius: "12px",
                        "&:hover": {
                          borderColor: "black",
                          cursor: "pointer",
                        },
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontWeight: "bold",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "black",
                        fontWeight: "bold",
                      }),
                      indicatorsContainer: (provided) => ({
                        ...provided,
                        color: "black",
                      }),
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: "black",
                        "&:hover": {
                          color: "black",
                        },
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        backgroundColor: "black",
                      }),
                      clearIndicator: (provided) => ({
                        ...provided,
                        color: "black",
                        "&:hover": {
                          color: "black",
                        },
                      }),
                    }}
                  />
                  <br />
                  <br />
                  <h5
                    style={{
                      fontSize: "1.8em",
                      fontWeight: "bolder",
                    }}
                  >
                    {localizationStrings.tripStep2Label}
                  </h5>
                  <br></br>
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      Your Select component and related code
                      <Select
                        value={
                          this.state.selectedLock
                            ? {
                                label: this.state.selectedLock.Name,
                                value: this.state.selectedLock.Id,
                              }
                            : null
                        }
                        onChange={this.detectOnLockDropdownChangeEvent}
                        options={this.renderDropdown()}
                        formatOptionLabel={({ label }) => label}
                        isClearable={true}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            outline: "none",
                            boxShadow: state.isFocused
                              ? "none"
                              : provided.boxShadow,
                            borderColor: state.isFocused
                              ? "black"
                              : provided.borderColor,
                            width: "100%",
                            backgroundColor: "white",
                            color: "black",
                            fontWeight: "bold",
                            border: "4px solid #3c3e41",
                            borderRadius: "12px",
                            "&:hover": {
                              borderColor: "black",
                              cursor: "pointer",
                            },
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            fontWeight: "bold",
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "black",
                            fontWeight: "bold",
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            color: "black",
                          }),
                          dropdownIndicator: (provided, state) => ({
                            ...provided,
                            color: "black",
                            "&:hover": {
                              color: "black",
                            },
                          }),
                          indicatorSeparator: (provided) => ({
                            ...provided,
                            backgroundColor: "black",
                          }),
                          clearIndicator: (provided) => ({
                            ...provided,
                            color: "black",
                            "&:hover": {
                              color: "black",
                            },
                          }),
                        }}
                      />
                      {this.state.isSharedLock && this.state.selectedLock ? (
                        this.state.selectedLock.shareStartTime > 0 &&
                        this.state.selectedLock.shareEndTime > 0 ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "1.3em",
                              marginTop: "20px",
                            }}
                          >
                            {localizationStrings.timedAccessLock1}{" "}
                            {this.convertStartTime(
                              this.state.selectedLock.shareStartTime
                            )}{" "}
                            {localizationStrings.timedAccessLock2}{" "}
                            {this.convertEndTime(
                              this.state.selectedLock.shareEndTime
                            )}{" "}
                            {localizationStrings.timedAccessLock3}
                          </p>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  </div> */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <LocksTable
                        visible={true}
                        dataCallBack={this.updateLockChanges}
                        selectedLock={this.state.selectedLocks}
                      />
                    </div>
                  </div>
                  <h5
                    style={{
                      fontSize: "1.8em",
                      fontWeight: "bolder",
                    }}
                  >
                    {localizationStrings.tripStep3Label}
                  </h5>
                  <br></br>
                  <div
                    // style={{ display: "flex", justifyContent: "space-between" }}
                    className="editTripFormTimeSelection"
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "1.3em",
                          fontWeight: "bold",
                          marginRight: "10px",
                          marginTop: "5px",
                        }}
                        className="editTripFormTimeSelectionLabel"
                      >
                        {localizationStrings.startLabel}
                      </div>
                      <div style={{ width: "200px", marginRight: "10px" }}>
                        <DatePicker
                          placeholderText={this.state.calendarStartText}
                          selected={this.state.startDate}
                          onChange={this.handleStartDateChange}
                          showTimeSelect
                          dateFormat="dd/MM/yyyy, HH:mm a"
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "1.3em",
                          fontWeight: "bold",
                          marginRight: "10px",
                          marginTop: "5px",
                        }}
                        className="editTripFormTimeSelectionLabel"
                      >
                        {localizationStrings.endLabel}
                      </div>
                      <div style={{ width: "200px" }}>
                        <DatePicker
                          placeholderText={this.state.calendarEndText}
                          selected={this.state.endDate}
                          onChange={this.handleEndDateChange}
                          showTimeSelect
                          dateFormat="dd/MM/yyyy, HH:mm a"
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <br />
                  <h5
                    style={{
                      fontSize: "1.8em",
                      fontWeight: "bolder",
                    }}
                  >
                    {localizationStrings.tripStep4Label}
                  </h5>
                  <br></br>
                  <div
                    style={{
                      width: "100%",
                      height: "600px",
                      position: "relative",
                    }}
                  >
                    <Map
                      google={this.props.google}
                      ref={this.mapRef}
                      onClick={this.onMapClick}
                      initialCenter={{ lat: 1.3521, lng: 103.8198 }}
                      zoom={this.state.mapZoom}
                      gestureHandling="cooperative"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "5px",
                      }}
                      options={{
                        disableDefaultUI: true,
                        gestureHandling: "none",
                      }}
                    >
                      {markers.map((marker, index) => (
                        <Marker
                          key={index}
                          icon={mapMarker}
                          position={{ lat: marker.lat, lng: marker.lng }}
                          title={marker.name}
                        />
                      ))}
                      {polylinePaths.map((path, index) => (
                        <Polyline
                          key={index}
                          path={path}
                          strokeColor="#FF0000"
                          strokeOpacity={1}
                          strokeWeight={3}
                          options={{
                            icons: [
                              {
                                icon: {
                                  path:
                                    window.google.maps.SymbolPath
                                      .FORWARD_CLOSED_ARROW,
                                  scale: 2.5,
                                  strokeColor: "#FF0000",
                                  fillColor: "#FF0000",
                                  fillOpacity: 1,
                                },
                                offset: "100%",
                                repeat: "100px",
                              },
                            ],
                          }}
                        />
                      ))}
                    </Map>
                  </div>
                  <br />
                  <br />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h5 style={{ fontSize: "1.8em", fontWeight: "bolder" }}>
                      {localizationStrings.selectedLocationsLabel}
                    </h5>
                    <div>
                      <input
                        type="text"
                        placeholder={
                          localizationStrings.searchLocationPlaceholder
                        }
                        value={locationName}
                        onChange={this.onLocationNameChange}
                        onKeyDown={this.onKeyDown}
                        style={{
                          border: "4px solid #3c3e41",
                          borderRadius: "12px",
                          width: "73%",
                          padding: "8px",
                          marginRight: "2%",
                        }}
                      />

                      <button
                        onClick={this.onFindLocation}
                        style={{
                          borderRadius: "12px",
                          width: "25%",
                          padding: "10px",
                          fontSize: "1.0 em",
                          backgroundColor: "orange",
                          color: "black",
                          cursor: "pointer",
                        }}
                      >
                        {localizationStrings.findLocationBtn}
                      </button>
                    </div>

                    <div
                      style={{
                        overflowY: "auto",
                        height: "300px",
                        maxHeight: "300px",
                        backgroundColor: "rgba(203, 203, 210, 0.15)",
                        border: "1px solid #ccc",
                        padding: "10px",
                        width: "100%",
                        borderRadius: "12px",
                        marginTop: "20px",
                      }}
                    >
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {this.state.locationList.map((location, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <span style={{ marginRight: "10px" }}>
                              {location.name}
                            </span>
                            {/* {location.name ? (
                              <span>
                                {location.name}: Latitude: {location.lat},
                                Longitude: {location.lng}
                              </span>
                            ) : (
                              <span>
                                Unnamed Location: Latitude: {location.lat},
                                Longitude: {location.lng}
                              </span>
                            )} */}
                            <div style={{ display: "flex", gap: "10px" }}>
                              {this.state.locationList.length > 1 && index > 0 && (
                                <button
                                  style={{
                                    borderRadius: "6px",
                                    padding: "5px 10px",
                                    fontSize: "0.8em",
                                    backgroundColor: "orange",
                                    color: "black",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => this.onReorderLocation(index)}
                                >
                                  <i className="fa fa-chevron-up"></i>
                                </button>
                              )}
                              <button
                                style={{
                                  borderRadius: "6px",
                                  padding: "5px 10px",
                                  fontSize: "0.8em",
                                  backgroundColor: "orange",
                                  color: "black",
                                  cursor: "pointer",
                                }}
                                onClick={() => this.onDeleteLocation(index)}
                              >
                                <span style={{ whiteSpace: "nowrap" }}>
                                  <b>{localizationStrings.removeBtn}</b>
                                </span>
                              </button>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <br />
                <Row>
                  <Button
                    className={"clearSendBtn"}
                    style={{ width: "100%", marginTop: "20px" }}
                    type="reset"
                    onClick={this.eraseAll}
                  >
                    {localizationStrings.clearBtn}
                  </Button>
                </Row>

                <Row>
                  <Button
                    className="loginsignupbutton"
                    style={{
                      width: "100%",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                    onClick={this.editActiveTrip}
                    // disabled={this.state.invalidMemberLimit || this.state.invalidLockLimit ? true : false}
                    disabled={
                      this.state.tripName === "" ||
                      this.state.tripName === null ||
                      this.state.selectedPIC === null ||
                      this.state.selectedLocks.length === 0 ||
                      this.state.locationList.length === 0 ||
                      this.state.startDate >= this.state.endDate ||
                      this.state.endDate <= new Date()
                        ? true
                        : false
                    }
                  >
                    <strong>{localizationStrings.saveBtn}</strong>
                  </Button>
                  <br />
                  <br />
                  <p style={{ textAlign: "center", color: "red" }}>
                    {this.state.tripName === "" || this.state.tripName === null
                      ? localizationStrings.errorMessage1
                      : this.state.selectedPIC === null
                      ? localizationStrings.selectPIC
                      : this.state.selectedLocks.length === 0
                      ? localizationStrings.errorMessage2
                      : this.state.locationList.length === 0
                      ? localizationStrings.errorMessage3
                      : this.state.startDate >= this.state.endDate ||
                        this.state.endDate <= new Date()
                      ? localizationStrings.errorMessage4
                      : ""}
                  </p>
                </Row>
              </div>
            </FormGroup>
          </form>
        </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
})(LockDropdownComponent);
